import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/ar-images/icon/cbys-icon2.png'
import _imports_1 from '@/assets/images/ar-images/icon/cjys-icon2.png'
import _imports_2 from '@/assets/images/ar-images/icon/yycj-vps1.png'
import _imports_3 from '@/assets/images/ar-images/icon/yycj-vps2.png'
import _imports_4 from '@/assets/images/ar-images/icon/yycj-vps3.png'
import _imports_5 from '@/assets/images/ar-images/icon/yycj-vps4.png'


const _hoisted_1 = { class: "header-video" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "boot-first" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "yycj" }
const _hoisted_7 = { class: "scene-list-box" }
const _hoisted_8 = { class: "type-list" }
const _hoisted_9 = { class: "package" }
const _hoisted_10 = { class: "package-list" }

import { ref, onMounted, onUnmounted, nextTick, watch } from 'vue'
import ContactUs from '@/components/ContactUs2.vue'
import router from '@/router';
import { asynchronousRetrieval } from '@/utils'
import store from '@/store';
import { modelTypes } from '@/config';
import SubTitle from '@/components/SubTitle.vue';
import ExampleIntroduction from '@/components/common/ExampleIntroduction.vue';
import { exampleDatas } from '@/config/index'

const MODEL = 'vision_ar_vps'

export default /*@__PURE__*/_defineComponent({
  __name: 'VPSView',
  setup(__props) {

const loadUrl: any = ref({})
const sceneTypeList = ['工业设计', '教育培训', '文博场馆', '城市规划', '停车场', '景区公园', '体育赛事', '商业街区', '历史遗迹', '演唱会', '科技馆', '旅游导览', '活动晚会', '娱乐体验', '大型会展', '智慧工厂']

let timer: any = null;

const toContact = () => {
  let contactUsTop: any = store.state.contactUsTop;
  contactUsTop = {
    bottom: 565 + 'rem'
  }
  store.state.contactUsTop = JSON.parse(JSON.stringify(contactUsTop))
}

onMounted(async () => {
  const vps_img: any = await asynchronousRetrieval('webimg/images/vps-img.png');
  loadUrl.value = { vps_img }
})

onUnmounted(() => {
  clearInterval(timer)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: loadUrl.value.vps_img
      }, null, 8, _hoisted_2),
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"video-text\" data-v-69b335e7><div class=\"logo-text\" data-v-69b335e7><span data-v-69b335e7>混空VPS</span></div><div class=\"link-room\" data-v-69b335e7>混空VPS（Visual Positioning System）由公司自主研发，是一款融合多源数据和AI视觉算法，提供高精度定位和环境感知，帮助开发者快速部署XR沉浸式体验的定位系统。</div><a class=\"experience-now\" href=\"https://vps.njyjxr.com\" data-v-69b335e7><span data-v-69b335e7>立即体验</span><div class=\"experience-btn\" data-v-69b335e7></div></a></div>", 1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title deep" }, [
        _createTextVNode("为你构建室内外稳定的"),
        _createElementVNode("span", { style: {"color":"#822EFF"} }, "空间计算能力")
      ], -1)),
      _createElementVNode("main", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelTypes)[MODEL], (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.header
          }, [
            _createElementVNode("img", {
              src: item.image,
              alt: ""
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", null, _toDisplayString(item.header), 1),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.remarkList, (remark) => {
                  return (_openBlock(), _createElementBlock("li", { key: remark }, _toDisplayString(remark), 1))
                }), 128))
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"wmdys\" data-v-69b335e7><div class=\"title\" data-v-69b335e7>我们的优势</div><div class=\"wmdys-content\" data-v-69b335e7><div class=\"left\" data-v-69b335e7><header data-v-69b335e7><img src=\"" + _imports_0 + "\" class=\"l-iamge\" alt=\"\" data-v-69b335e7><div class=\"r-head\" data-v-69b335e7>成本优势</div></header><div class=\"line\" data-v-69b335e7>· 技术使用成本低；</div><div class=\"line\" data-v-69b335e7>· 云SAAS化服务降低使用门槛。</div></div><div class=\"right\" style=\"padding-right:50rem;box-sizing:border-box;\" data-v-69b335e7><header data-v-69b335e7><img src=\"" + _imports_1 + "\" class=\"l-iamge\" alt=\"\" data-v-69b335e7><div class=\"r-head\" data-v-69b335e7>场景优势</div></header><div class=\"line\" data-v-69b335e7>· 现实空间三维建图、复杂环境感知、视觉导航上优势显著；</div><div class=\"line\" data-v-69b335e7>· 在城市级别大空间和复杂环境定位上优势显著，如商业广场、博物馆、历史遗迹等；</div><div class=\"line\" data-v-69b335e7>· 在机器人、自动驾驶、医疗、消费电子等领域具备可拓展前景。</div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_6, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title deep" }, "应用场景", -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sceneTypeList, (item) => {
            return _createElementVNode("div", { key: item }, _toDisplayString(item), 1)
          }), 64))
        ]),
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"scene-list\" data-v-69b335e7><img src=\"" + _imports_2 + "\" data-v-69b335e7><img src=\"" + _imports_3 + "\" data-v-69b335e7><img src=\"" + _imports_4 + "\" data-v-69b335e7><img src=\"" + _imports_5 + "\" data-v-69b335e7></div>", 1))
      ])
    ]),
    _createVNode(ExampleIntroduction, {
      "mode-class": "pop-style-light",
      "title-class": "title",
      exampleData: _unref(exampleDatas).kjsj
    }, null, 8, ["exampleData"]),
    _createElementVNode("div", _hoisted_9, [
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "title deep" }, "按需选择 灵活购买", -1)),
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "title-tips deep" }, "混空VPS产品体系", -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, [
          _cache[6] || (_cache[6] = _createElementVNode("div", null, "有并发要求", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "suv-title2" }, "标准服务包含", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "service-content" }, [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, "定位面积"),
              _createElementVNode("span", null, "定位服务时长"),
              _createElementVNode("span", null, "并发数量"),
              _createElementVNode("span", null, "技术支持")
            ])
          ], -1)),
          _createElementVNode("div", {
            class: "contact-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (toContact()))
          }, "立即咨询"),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "contact-tips" }, "可根据您的项目实际情况，购买标准服务(支持按需扩展单项)", -1))
        ]),
        _createElementVNode("div", null, [
          _cache[10] || (_cache[10] = _createElementVNode("div", null, "无并发要求", -1)),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "suv-title2" }, "标准服务包含", -1)),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "service-content" }, [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, "定位面积"),
              _createElementVNode("span", null, "定位服务时长"),
              _createElementVNode("span", null, "技术支持")
            ])
          ], -1)),
          _createElementVNode("div", {
            class: "contact-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (toContact()))
          }, "立即咨询"),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "contact-tips" }, "可根据您的项目实际情况，购买标准服务(支持按需扩展单项)", -1))
        ])
      ])
    ]),
    (_unref(store).state.contactUsTop)
      ? (_openBlock(), _createBlock(ContactUs, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})